import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import { createQueryKey } from '@/lib/react-query'
import CrudService from '@/services/crudService'

const resource = API_RESOURCE.VENDOR
const VendorService = {
  resource: resource,
  queryKey: createQueryKey(resource),

  registerTempVendor: async (data) => {
    const response = await axios.post(`${resource}/registerTemp`, data)

    return response.data
  },
}

export default VendorService
